import {Pencil, Trash2} from 'lucide-react';
import {Button} from 'src/Button';
import {useModals} from 'src/Modals';
import type {FullUnitFragment} from '@transactions/graphql';

type Props = {
  unit: FullUnitFragment;
  onUpdate: () => void;
};

export const UnitCard = (props: Props) => {
  const {unit, onUpdate} = props;
  const {editUnitModal, deleteUnitModal} = useModals();

  const handleEdit = () => {
    editUnitModal.openModal({unit, onSuccess: onUpdate});
  };

  const handleDelete = () => {
    deleteUnitModal.openModal({unit, onDeleted: onUpdate});
  };

  const exampleAmount = (3).toFixed(unit.displayDecimals);

  return (
    <div className="border-border bg-card rounded-lg border p-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium">{unit.name}</h3>
            <span className="bg-muted text-muted-foreground rounded px-1.5 py-0.5 text-xs font-medium">
              1 {unit.singular} · {exampleAmount} {unit.plural}
            </span>
          </div>
          {unit.description && (
            <p className="text-muted-foreground mt-1 text-sm">
              {unit.description}
            </p>
          )}
        </div>
        <div className="flex gap-1">
          <Button size="icon" variant="ghost" onClick={handleEdit}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button size="icon" variant="ghost" onClick={handleDelete}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
